class SaftController extends AbstractController
	@registerController()
	@inject '$scope',
		'$filter'
		'shops'
		'registers'
		'BACKEND_REPORT_TYPE'
		'BACKEND_SAFT_VERSION'
		'BACKEND_SUBSCRIBER_ENTITY_TYPE'
		'ConfigurationService'
		'MessageTerminal'
		'ReportService'
		'UserInformation'

	initialize: ->
		# @TODO: Must select type when NO have 2 SAF-T implemented
		@autoVersionSelect = true
		@subscriptionKey = @BACKEND_SUBSCRIBER_ENTITY_TYPE.SAFT
		@errorMessages = {}
		@hasErrors = false
		@versions = {}
		@filter =
			email: null
			data:
				shop_id: null
				register_id: null
				from: null
				to: null
				version: null
				report_type: @BACKEND_REPORT_TYPE.SAFT

		@MessageTerminal.on @$scope, @MessageTerminal.events.BACKGROUND_PROCESS.COMPLETE, => @loadReports()
		@MessageTerminal.on @$scope, @MessageTerminal.events.BACKGROUND_PROCESS.ERROR, => @loadReports()

		for key, version of @BACKEND_SAFT_VERSION
			@versions[version] = 'general.reports.saf-t.version.' + version

		@enabledVersions = []
		@enabledVersions.push(@BACKEND_SAFT_VERSION.NORWAY_CASH_REGISTER) if @ConfigurationService.isEnabled 'Shared.Setting.SaftNoCrReport.Enabled'
		@enabledVersions.push(@BACKEND_SAFT_VERSION.DENMARK_CASH_REGISTER) if @ConfigurationService.isEnabled 'Shared.Setting.SaftDkCrReport.Enabled'
		@enabledVersions.push(@BACKEND_SAFT_VERSION.PORTUGAL) if @ConfigurationService.isEnabled 'Shared.Setting.SaftPtReport.Enabled'

		@filterRegisters()
		@setVersion()
		@validateMasterUser()
		@loadReports()

	setVersion: ->
		if @enabledVersions.length == 1
			@filter.data.version = @enabledVersions[0]

			return

		return if !@autoVersionSelect

		countryCode = @UserInformation.getMasterUser().country_code.toLowerCase()
		@filter.data.version = null

		if @enabledVersions.includes(@BACKEND_SAFT_VERSION.PORTUGAL) && ['pt', 'prt'].includes(countryCode)
			@filter.data.version = @BACKEND_SAFT_VERSION.PORTUGAL

		if @enabledVersions.includes(@BACKEND_SAFT_VERSION.NORWAY_CASH_REGISTER) && ['no', 'nor'].includes(countryCode)
			@filter.data.version = @BACKEND_SAFT_VERSION.NORWAY_CASH_REGISTER

		if @enabledVersions.includes(@BACKEND_SAFT_VERSION.DENMARK_CASH_REGISTER) && countryCode == 'dk'
			@filter.data.version = @BACKEND_SAFT_VERSION.DENMARK_CASH_REGISTER

		@filter.data.version = @enabledVersions[0] if !@filter.data.version?

	validateMasterUser: ->
		return if not @filter.data.version?

		@ReportService
			.validate @BACKEND_REPORT_TYPE.SAFT, @filter.data.version
			.then (errors) =>
				@hasErrors = false

				if not _.isEmpty errors
					@hasErrors = true

					for own key, error of errors
						@errorMessages[key] = @$filter('translate')(error.key)

	filterRegisters: ->
		@filteredRegisters = angular.copy @registers

		if @filter.data.shop_id?
			@filteredRegisters = _.filter @filteredRegisters, {shop_id: @filter.data.shop_id}

	loadReports: ->
		@ReportService
			.search {report_type: @BACKEND_REPORT_TYPE.SAFT}
			.then (entities) =>
				@reports = entities

	download: (file) ->
		@ReportService.download(file)

	hasErrorMessages: ->
		return @hasErrors
